import { PMT } from "../classes/Enum"

const PaymentMethodComponent = ({setPaymentMethod}) => {
    return <div className="row">
        <button onClick={() => setPaymentMethod(PMT.CARD)}>
            <img src="/assets/svgs/card.svg"></img>
        </button>
        <h3 style={{padding:'20px'}}>OR</h3>
        <button onClick={() => setPaymentMethod(PMT.PAYID)}>
            <img src="/assets/imgs/pay_id.png"></img>
        </button>
    </div>
}

export default PaymentMethodComponent